<template>
    <div>
        <div class="border-0 pl-0 pr-0 no-shadow">
            <div class="row pt-4 pb-3">
                <div class="col-12">
                    <p class="text-overline text-uppercase text-secondary">{{trans('community.reflection')}}:</p>
                </div>

                <div class="col-12">
                    <h5 class="text-primary">{{question}}</h5>
                </div>

                <div class="col-12">
                    <hr/>
                </div>
                <div class="col-12 d-flex justify-content-end">
                    <privacy-alert
                        buttonSize="sm"
                        :popupContent="transChoice('community.anyone_can_read',companyName, {company: companyName})"
                        :popupButton="trans('global.more_info')"
                        :popupHref="{name: 'privacy-legend'}"
                        popoverId="privacyPopover"
                        v-bind:targetBlank="true"
                        pill
                    >
                        <img src="/images/icon_company.svg" width="24px" class="pr-1" /> {{ this.companyName }}
                    </privacy-alert>
                    <div class="ml-2" v-if="moderation !== 0">
                        <privacy-alert
                            buttonSize="sm"
                            :popupContent="transChoice('community.moderation_badge', companyName, {company: companyName})"
                            :popupButton="trans('community.moderation_badge_link')"
                            :popupHref="{name: 'privacy-legend'}"
                            popoverId="moderationPopover"
                            v-bind:targetBlank="true"
                        >
                            <img src="/images/moderation.svg" height="21px" />
                        </privacy-alert>
                    </div>
                </div>

                <div class="col-12 mt-4 d-flex justify-content-center" v-if="!userHasPost">
                    <b-button v-b-modal.post-community-modal variant="light" pill class="text-bold shadowed text-secondary">
                        {{trans('community.write_a_think')}}
                    </b-button>
                </div>
            </div>
        </div>
        <div class="row mx-0">
            <div class="col-12 d-flex justify-content-center">
                <p class="caption mb-0">{{totalWritten}}</p>
            </div>
            <div class="col-12" v-if="allPosts === 0">
                <div class="row justify-content-center bg-primary-light mt-5">
                    <div class="col-12 col-md-8 py-5 text-center">
                        <h6 class="text-primary">{{trans('community.no_posts_description_1')}}</h6>
                        <p>{{trans('community.no_posts_description_2')}}</p>
                    </div>
                </div>
            </div>

            <div v-else class="col-12 py-3 px-0">
                <community-masonry
                        :posts="this.posts"
                        :module-id="moduleId"
                        :userPost="userPost"
                        :user-has-post="userHasPost"
                        :on-like-post="onLikePost"
                        @onDelete="onDeleteUserPost"
                        @editUserPost="onEditUserPost"
                />
            </div>
        </div>
        <post-community-modal
            :module-id="moduleId"
            :user-post="editPost"
            :post-title="question"
            :post-loading="loading"
            @onCreatePost="onCreatePost"
            @onEditPost="onEditPost"
        />
        <privacy-modal :companyName="companyName" />
    </div>
</template>

<script>
    import CommunityMasonry from "../organisms/CommunityMasonry";
    import PostCommunityModal from "../organisms/PostCommunityModal";
    import PrivacyAlert from "../molecules/PrivacyAlert"
    import PrivacyModal from "../molecules/PrivacyModal"
    import { mapGetters } from "vuex";

    export default {
        name: "CommunityLogBook",
        components: { CommunityMasonry, PostCommunityModal, PrivacyAlert, PrivacyModal },
        props:{
            moduleId: Number,
            miuId: String,
            userId: Number,
            question: String,
            companyName: String,
            communityPosts: Array,
            communityUserPost: Object,
        },
        data(){
            return {
                posts: this.communityPosts,
                userPost: this.communityUserPost,
                editPost: {},
                moderation: 0,
                loading: false,
                doingLike: false
            }
        },
        computed: {
            ...mapGetters({
                locale: 'user/getLocale'
            }),
            totalWritten: function() {
                if(this.allPosts === 0){
                    return this.trans('community.no_posts');
                }
                return this.userHasPost ? this.transChoice('community.you_and_has_written', this.posts.length, {coll_num: this.posts.length}) : '';
            },
            allPosts: function() {
                return this.posts.length + (this.userHasPost ? 1 : 0)
            },
            userHasPost(){
                return this.userPost !== null;
            }
        },
        methods:{
            onDeleteUserPost(){
                this.$axios.delete(`/api/rest/community/post/${this.userPost.id}`)
                    .then((res)=>{
                        this.userPost = null;
                        this.editPost = {};
                    })
                    .catch((e)=>{
                        console.log(e);
                    })
            },
            onEditUserPost(){
                this.editPost = this.userPost;
                this.$root.$emit('bv::show::modal', 'post-community-modal', '#postButton')
            },
            onCreatePost(postData){
                this.loading = true;
                this.$axios.post('/api/rest/community/post', this.addIdentifier(postData))
                    .then((res)=>{
                        this.userPost = res.data.data[0];
                        this.loading = false;
                        this.$root.$emit('bv::hide::modal', 'post-community-modal', '#postButton');
                    })
                    .catch((e)=>{
                        this.loading = false;
                        console.log(e);
                    })
            },
            onEditPost(editData){
                this.loading = true;
                this.$axios.put(`/api/rest/community/post/${editData.id}`, this.addIdentifier(editData))
                    .then((res)=>{
                        this.userPost = res.data.data[0];
                        this.loading = false;
                        this.$root.$emit('bv::hide::modal', 'post-community-modal', '#postButton');
                    })
                    .catch((e)=>{
                        this.loading = false;
                        console.log(e);
                    })
            },
            onLikePost(postId, nOfLikes, alreadyLiked){
                if(!this.doingLike){
                    this.doingLike = true;
                    this.$axios.post(`/api/rest/community/post/${postId}/reaction`, { post_id: postId, reaction_type: 'like' })
                        .then((res)=>{
                            if (this.userPost && this.userPost.id === postId) {
                                if (alreadyLiked === false) {
                                    this.userPost.reaction = 'like'
                                    this.userPost.likes += 1
                                } else {
                                    this.userPost.reaction = null
                                    this.userPost.likes -= 1
                                }
                            } else {
                                const likedPost = this.posts.filter(post => post.id === postId)
                                if (alreadyLiked === false) {
                                    likedPost[0].reaction = 'like'
                                    likedPost[0].likes += 1
                                } else {
                                    likedPost[0].reaction = null
                                    likedPost[0].likes -= 1
                                }

                            }

                            this.doingLike = false;
                        })
                        .catch((e)=>{
                            console.log(e);
                        })
                }
            },
            addIdentifier(postData){
                let data;
                let trackingData;
                const params = this.$route.params;
                if(this.miuId){
                    data = {
                        ...postData,
                        miu_id: this.miuId,
                        stream_id: params.id,
                        ale_id: params.aleId,
                        stream_localization: params.localisation,
                        title_locale: this.locale,
                        description_locale: this.locale,
                    }
                    trackingData = {
                        "stream-id": this.$route.params.id,
                        "miu-id": this.miuId,
                    };
                }else{
                    data = { ...postData, module_id: this.moduleId}
                    trackingData = {
                        "module-id": this.moduleId,
                    };
                }
                trackEvent(`PostCollectiveRoom`, trackingData);
                return data;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .h5 {
        font-size: 1.5rem !important;
    }
</style>
